module.exports = __webpack_public_path__ + "static/media/elena.d2b2c87e.jpg";